/* eslint-disable no-unused-vars */
import 'focus-visible'
import Behavior from './dsgov.beahavior'
import Globals from './globals-class'

const globals = new Globals()
// globals.initInstanceAll()

const behavior = new Behavior()
behavior.initInstanceAll()
